<script lang="ts">
	import { Router, Route } from "svelte-navigator";
	import Callback from "./authentication/Callback.svelte";
	import Scenario from "./scenario/Scenario.svelte";
	import PrivateRoute from "./authentication/PrivateRoute.svelte";
	import Login from "./authentication/Login.svelte";
	import Home from "./Home.svelte";
	import Logout from "./authentication/Logout.svelte";
	import Project from "./project/Project.svelte";
	import { appManager } from "./AppManager";
	import Silent from "./authentication/Silent.svelte";
	import ReRoute from "./reroute/ReRoute.svelte";
	import RandomPointsModal from "./od/random-points/RandomPointsModal.svelte";
	import NewOdModal from "./od/NewOdModal.svelte";
	import TripsModal from "./od/trips/TripsModal.svelte";
	import ScenarioDeleteConfirmModal from "./project/scenarios/ScenarioDeleteConfirmModal.svelte";
	import { _, getLocaleFromNavigator, init, addMessages } from "svelte-i18n";
	import en from "./locales/en.json";
	import nl from "./locales/nl.json";
	import ProjectDeleteConfirmModal from "./project/scenarios/ProjectDeleteConfirmModal.svelte";
	import OdCopModal from "./od/OdCopyModal.svelte";
	import Signout from "./authentication/Signout.svelte";
	import SharedScenario from "./scenario/shared/SharedScenario.svelte";
	import DeleteConfirmModal from "./shared/modals/DeleteConfirmModal.svelte";
	import NotFound from "./NotFound.svelte";
	import OdEditModal from "./od/edit/OdEditModal.svelte";
	import TripsLayerSettingsModal from "./shared/modals/TripsLayerSettingsModal.svelte";
	import DemandModelModal from "./od/demand-model/DemandModelModal.svelte";
	import "tippy.js/dist/tippy.css";
	import ReRouteProjectView from "./reroute/ReRouteProjectView.svelte";

	// locale setup
	addMessages("en", en);
	addMessages("nl", nl);
	init({
		fallbackLocale: "en",
		initialLocale: getLocaleFromNavigator(),
	});

	const initialProfiles = [
		"bicycle.comfort_safety",
		"bicycle.comfort",
		"bicycle.commute",
		"bicycle.fast",
		"bicycle.safety",
		"bicycle.short",
		"car.fast",
		"car.short",
		"car.classifications",
		"bigtruck.fast",
		"bigtruck.short",
		"pedestrian.short",
		"pedestrian.slow_roads",
	];
	const profiles: string[] = [];
	initialProfiles.forEach((profile) => {
		profiles.push(profile);
		profiles.push(`${profile}.5%`);
		profiles.push(`${profile}.10%`);
	});

	// initialize app with settings.
	appManager.initialize({
		publicUrl: new URL("process.env.BASEURL"),
		apiSettings: {
			randomLocationsApi: "process.env.RANDOM_LOCATIONS_API",
			editApi: "process.env.EDIT_APIS",
			identityApi: "process.env.AUTHORITY",
			tripsApi: "process.env.TRIPS_API",
			projectsApi: "process.env.IMPACT_API",
			publishApi: "process.env.PUBLISH_API",
			publishApiTiles: "process.env.PUBLISH_API_TILES",
			demandModelApi: "process.env.DEMAND_MODEL_API",
		},
		apiKeys: {
			opencage: "dcec93be31054bc5a260386c0d84be98",
		},
		profiles: profiles,
	});

	const publicUrl = new URL("process.env.BASEURL");
</script>

<DemandModelModal />
<RandomPointsModal />
<NewOdModal />
<TripsModal />
<ScenarioDeleteConfirmModal />
<ProjectDeleteConfirmModal />
<OdCopModal />
<DeleteConfirmModal />
<OdEditModal />
<TripsLayerSettingsModal />

<Router basepath={publicUrl.pathname ?? ""}>
	<PrivateRoute path="/" optional={true}>
		<Home />
	</PrivateRoute>

	<Route path="callback">
		<Callback />
	</Route>

	<Route path="silent">
		<Silent />
	</Route>

	<Route path="logout">
		<Logout />
	</Route>

	<!-- These signout/signin routes are only for local dev. -->
	<Route path="signout">
		<Signout />
	</Route>
	<Route path="signin">
		<Login />
	</Route>

	<PrivateRoute path="/project/:id" let:params>
		<Project id={params.id} />
	</PrivateRoute>

	<Route path="/project/:id/routeplanners" let:params>
		<ReRouteProjectView id={params.id} />
	</Route>

	<Route path="/routeplanner/:id" let:params>
		<ReRoute id={params.id} />
	</Route>

	<PrivateRoute path="/scenario/:id" needsPlan={true} let:params>
		<Scenario id={params.id} />
	</PrivateRoute>

	<Route path="/shared/scenario/:id" let:params>
		<SharedScenario id={params.id} />
	</Route>

	<Route path="/notfound" let:params>
		<NotFound />
	</Route>

	<Route>
		<h3>404</h3>
		<p>No Route could be matched.</p>
	</Route>
</Router>

<style>
</style>
